/**
 * Mapeamento centralizado de IDs de comidas para os possíveis nomes 
 * que aparecem nos pairings dos vinhos.
 * 
 * Este é o único lugar onde esse mapeamento deve existir (Single Source of Truth).
 */
export const FOOD_PAIRING_VARIATIONS = {
  'massas': ['Massas'],
  'carnes-vermelhas': ['Carnes vermelhas'],
  'carnes-grelhadas': ['Carnes grelhadas'],
  'queijos': ['Queijos'],
  'peixes': ['Peixes', 'Frutos do mar'], // Inclui frutos do mar
  'aves': ['Aves'],
  'fondues': ['Fondues'],
  'churrasco': ['Churrasco', 'Carnes vermelhas'], // Aceita ambos
  'comida-arabe': ['Comida Árabe']
};

/**
 * Filtra vinhos que harmonizam com uma determinada comida
 * @param {Array} wines - Array de vinhos
 * @param {string} foodId - ID da comida (ex: 'massas', 'carnes-vermelhas')
 * @param {boolean} onlyVisible - Se true, retorna apenas vinhos visíveis (padrão: true)
 * @returns {Array} - Array de vinhos filtrados
 */
export const filterWinesByFood = (wines, foodId, onlyVisible = true) => {
  const variations = FOOD_PAIRING_VARIATIONS[foodId] || [];
  
  return wines.filter(wine => {
    // Verifica se o vinho está visível (se onlyVisible for true)
    const isVisible = !onlyVisible || wine.visible !== false;
    
    // Verifica se o vinho harmoniza com a comida
    const matchesPairing = variations.some(variation => wine.pairings.includes(variation));
    
    return isVisible && matchesPairing;
  });
};

/**
 * Verifica se uma comida tem vinhos disponíveis
 * @param {Array} wines - Array de vinhos
 * @param {string} foodId - ID da comida
 * @param {boolean} onlyVisible - Se true, verifica apenas vinhos visíveis (padrão: true)
 * @returns {boolean} - True se há pelo menos um vinho para essa comida
 */
export const hasFoodWines = (wines, foodId, onlyVisible = true) => {
  const variations = FOOD_PAIRING_VARIATIONS[foodId] || [];
  
  return wines.some(wine => {
    // Verifica se o vinho está visível (se onlyVisible for true)
    const isVisible = !onlyVisible || wine.visible !== false;
    
    // Verifica se o vinho harmoniza com a comida
    const matchesPairing = variations.some(variation => wine.pairings.includes(variation));
    
    return isVisible && matchesPairing;
  });
};

/**
 * Filtra apenas comidas que têm vinhos visíveis associados
 * @param {Array} foods - Array de comidas
 * @param {Array} wines - Array de vinhos
 * @returns {Array} - Array de comidas filtradas
 */
export const getAvailableFoods = (foods, wines) => {
  return foods.filter(food => hasFoodWines(wines, food.id));
};

